export * from './ConfigureDocumentTabs';
